import { Injectable } from '@angular/core';
import {Restangular} from 'ngx-restangular';
import {PlaylistService} from "@catmodels/avod-catalog/services/playlist.service";

@Injectable()
export class ProjectPlaylistService extends PlaylistService {

  constructor(service: Restangular) {
    super('project-avod-catalog-playlists', service);
  }
}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_master@2/app/Resources/Public/src/app/modules/models/avod-catalog/services/project-playlist.service.ts